<header class="header vinavon">
    <div style="flex:1; align-self: center; flex-direction: row; display: flex; gap: 10px;">
        <div>
            <mat-icon (click)="isExpanded = !isExpanded" [ngClass]="{ rotated: isExpanded }" class="chevron-button low">chevron_right</mat-icon>
        </div>
        <div>
            <mat-icon>person</mat-icon>
            <span>{{ currentUser }}</span>
        </div>
        <div>
            <mat-icon>apartment</mat-icon>
            <span>{{ currentMandant }}</span>
        </div>
        <div>
            <mat-icon>rule_settings</mat-icon>
            <span>{{ vinavonVersion }}</span>
        </div>
        <button (click)="svcVinavonUpdate.askUserToDoUpdate()" *ngIf="svcVinavonUpdate.updateFound | async" class="btn-block" color="warn" mat-stroked-button
                style="align-self: center; background-color: white; border-color: red">Update
            vinavon
        </button>
    </div>
    <app-header-layout>
        <ng-container *ngIf="showVinavon">
            <mat-icon (click)="openTasks()" [matBadgeHidden]="cntTasks == 0" aria-hidden="false" class="material-icons icon_color" matBadge="{{ cntTasks }}" matBadgeColor="warn"
                      matTooltip="{{ 'MAIN_APP_DASHBOARD.pendenteAufgaben' | translate }}">rule
            </mat-icon>
            <mat-icon (click)="openNotes()" [matBadgeHidden]="cntNotes == 0" aria-hidden="false" class="material-icons icon_color" matBadge="{{ cntNotes }}" matBadgeColor="warn"
                      matTooltip="{{ 'MAIN_APP_DASHBOARD.notizen' | translate }}">content_paste
            </mat-icon>
            <mat-icon (click)="openAppointments()" [matBadgeHidden]="cntAppointmentsToday == 0" aria-hidden="false" class="material-icons icon_color" matBadge="{{ cntAppointmentsToday }}"
                      matBadgeColor="warn"
                      matTooltip="{{ 'MAIN_APP_DASHBOARD.termin' | translate }}">assignment
            </mat-icon>
        </ng-container>

        <mat-icon [matMenuTriggerFor]="menu" class="material-icons icon_color" matTooltip="{{ 'MAIN_APP_DASHBOARD.einstellungen' | translate }}">settings
        </mat-icon>
        <mat-menu #menu="matMenu" class="shadow">
            <button mat-menu-item routerLink="/appeinstellungen">{{ 'MAIN_APP_DASHBOARD.einstellungen' | translate }}</button>
            <button (click)="logout()" mat-menu-item>{{ "MAIN_APP_DASHBOARD.abmelden" | translate }}</button>
        </mat-menu>

    </app-header-layout>
</header>

<div style="display: flex; flex-direction: row; width: 100%; height: 100%; overflow: hidden;">
    <mat-sidenav #sidenav [ngClass]="{'closed': !isExpanded}" mode="side" opened="isExpanded" style="position: absolute; background-color: white;">
        <mat-nav-list style="padding: 0;">
            <ng-container *ngIf="showVinavon">
                <mat-list-item (click)="isExpanded = false" [ngClass]="{'active': (currentRoute$ | async) == 'dashboard' }" [routerLink]="'dashboard'"
                               matTooltip='{{ "MAIN_APP_DASHBOARD.dashboard" | translate }}' matTooltipPosition="right">
                    <mat-icon class="menu-icon low">dashboard</mat-icon>
                    <span class="menu-item">{{ "MAIN_APP_DASHBOARD.dashboard" | translate }}</span>
                </mat-list-item>

                <mat-list-item (click)="isExpanded = false" [ngClass]="{'active': (currentRoute$ | async) == 'adressen' }" [routerLink]="'adressen'" matTooltip='{{ "MAIN_APP_DASHBOARD.adressen" | translate }}'
                               matTooltipPosition="right">
                    <mat-icon class="menu-icon low">contact_mail</mat-icon>
                    <span class="menu-item">{{ "MAIN_APP_DASHBOARD.adressen" | translate }}</span>
                </mat-list-item>

                <mat-list-item (click)="isExpanded = false" [ngClass]="{'active': (currentRoute$ | async) == 'objekte' }" [routerLink]="'objekte'" matTooltip='{{ "MAIN_APP_DASHBOARD.objekte" | translate }}'
                               matTooltipPosition="right">
                    <mat-icon class="menu-icon low">home_work</mat-icon>
                    <span class="menu-item">{{ "MAIN_APP_DASHBOARD.objekte" | translate }}</span>
                </mat-list-item>

                <mat-list-item (click)="isExpanded = false" [ngClass]="{'active': (currentRoute$ | async) == 'pendenzen' }" [routerLink]="'pendenzen'" matTooltip='{{ "MAIN_APP_DASHBOARD.termine" | translate }}'
                               matTooltipPosition="right">
                    <mat-icon class="menu-icon low"> event_note</mat-icon>
                    <span class="menu-item">{{ "MAIN_APP_DASHBOARD.termine" | translate }}</span>
                </mat-list-item>
            </ng-container>
            <mat-list-item (click)="isExpanded = false" *ngIf="showServiceApp" [ngClass]="{'active': (currentRoute$ | async) == 'serviceapp' }" [routerLink]="'serviceapp/saagenda'"
                           matTooltip='{{ "MAIN_APP_DASHBOARD.serviceApp" | translate }}' matTooltipPosition="right">
                <mat-icon class="menu-icon low"> home_repair_service</mat-icon>
                <span class="menu-item">{{ "MAIN_APP_DASHBOARD.serviceApp" | translate }}</span>
            </mat-list-item>

            <mat-list-item (click)="isExpanded = false" *ngIf="showTimeApp" [routerLink]="'timeapp'" matTooltip='{{ "MAIN_APP_DASHBOARD.zeiterfassungsApp" | translate }}' matTooltipPosition="right">
                <mat-icon class="menu-icon low"> schedule</mat-icon>
                <span class="menu-item">{{ "MAIN_APP_DASHBOARD.zeiterfassungsApp" | translate }}</span>
            </mat-list-item>

            <mat-divider></mat-divider>

            <ng-container *ngIf="showVinavon">
                <mat-list-item (click)="neueAufgabe()" matTooltip='{{ "MAIN_APP_DASHBOARD.aufgabe" | translate }}' matTooltipPosition="right">
                    <mat-icon class="menu-icon low">rule</mat-icon>
                    <span class="menu-item">{{ "MAIN_APP_DASHBOARD.aufgabe" | translate }}</span>
                </mat-list-item>

                <mat-list-item (click)="neueNotiz()" matTooltip='{{ "MAIN_APP_DASHBOARD.notiz" | translate }}' matTooltipPosition="right">
                    <mat-icon class="menu-icon low">content_paste</mat-icon>
                    <span class="menu-item">{{ "MAIN_APP_DASHBOARD.notiz" | translate }}</span>
                </mat-list-item>

                <mat-list-item (click)="neuerTermin()" matTooltip='{{ "MAIN_APP_DASHBOARD.termin" | translate }}' matTooltipPosition="right">
                    <mat-icon class="menu-icon low">assignment</mat-icon>
                    <span class="menu-item">{{ "MAIN_APP_DASHBOARD.termin" | translate }}</span>
                </mat-list-item>

                <mat-divider class="logo-divider"></mat-divider>
            </ng-container>

            <div [ngClass]="{'expandedImage': isExpanded}" class="logo-box">
                <img alt="image" src="assets/images/swiss-soft-logo_zentriert_black.svg" style="padding: 2px;">
            </div>
        </mat-nav-list>
    </mat-sidenav>

    <!--Hidden sidenave for spacing-->
    <mat-sidenav class="closed hidden sidenav" mode="side" opened="isExpanded" style="position: relative; z-index: 0; visibility: hidden; ">
        <mat-nav-list style="padding: 0;">
            <mat-list-item *ngIf="showVinavon || showServiceApp || showTimeApp">
                <mat-icon class="menu-icon low">dashboard</mat-icon>
                <span class="menu-item">{{ "MAIN_APP_DASHBOARD.dashboard" | translate }}</span>
            </mat-list-item>
        </mat-nav-list>
    </mat-sidenav>
    <!--Hidden sidenave for spacing-->

    <div style="flex: 1; overflow-y: auto;">
        <router-outlet></router-outlet>

    </div>

</div>
